const SET_USER_INFO = 'SET_USER_INFO';

// initial state
const authState = {
	userInfo: window.userInfo
};

const authActions = {
	setUserInfo({ commit }, userInfo) {
		commit(SET_USER_INFO, userInfo);
	}
};

const authGetters = {
	fullName(state) {
		return state.userInfo ? state.userInfo.name : null;
	},
	isLoggedIn(state) {
		return !!state.userInfo;
	}
};

const authMutations = {
	[SET_USER_INFO](state, userInfo) {
		state.userInfo = userInfo;
	}
};

export default {
	namespaced: true,
	state: authState,
	getters: authGetters,
	mutations: authMutations,
	actions: authActions
};
